import { UserDetails } from 'src/types/common';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { diContainer } from 'src/inversify.config';
import GetCurrentUserUseCase from 'src/features/auth/domain/useCases/GetCurrentUserUseCase';
import { useMemo } from 'react';

const getCurrentUserUseCase = diContainer.get<GetCurrentUserUseCase>(
  GetCurrentUserUseCase
);

interface UseCurrentUserQueryParams {
  initialUser: UserDetails | undefined;
}

export const useCurrentUserQuery = ({
  initialUser,
}: UseCurrentUserQueryParams) => {
  const queryKey = useMemo(
    () => ['currentUser', initialUser?.pk],
    [initialUser?.pk]
  );

  const currentUserQuery = useQuery({
    queryKey,
    queryFn: () => getCurrentUserUseCase.execute(),
    enabled: !!initialUser,
    initialData: initialUser ? { ...initialUser, updated: false } : initialUser,
  });

  const hasProfile = !!currentUserQuery.data?.profile;

  return {
    ...currentUserQuery,
    currentUser: hasProfile ? currentUserQuery.data : undefined,
    queryKey,
  };
};

useCurrentUserQuery.getQueryKey = (
  params?: { userId: number },
  exact: boolean = false
): QueryKey => {
  if (!params || !exact) {
    return ['currentUser'];
  }
  const { userId } = params;

  return ['currentUser', userId];
};
